import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: "5px",
    border: "1px solid",
    borderColor: theme.palette.events.dialogHeaderBackground,
  },
}));
